{
  "dashboard": {
    "section_title": "Your Opportunities",
    "stats": {
      "total_open": "Total open opportunities",
      "total_won": "Total won opportunities",
      "success_rate": "Your success rate",
      "loading": "Loading opportunities stats..."
    },
    "create": {
      "reminder_title": "Don't forget to track your opportunities.",
      "reminder_description": "Have you received a referral or identified a new business opportunity? Track it here to stay organized and follow up effectively.",
      "button_text": "Create new opportunity"
    }
  },
  "basic_opportunities_page": {
    "advanced_button": "Advanced",
    "create_opportunity_button": "Create Opportunity",
    "all_opportunities_tab": "All Opportunities"
  },
  "archive_opportunity": {
    "confirm_content": "This action cannot be undone",
    "confirm_title": "Are you sure you want to archive this opportunity?",
    "archive_title": "Archive Opportunity"
  },
  "duplicate_goal": {
    "header": "Duplicate Opportunity",
    "aria_label": "duplicate opportunity",
    "title": "Duplicate Opportunity"
  },
  "opportunity_grid": {
    "actions_menu": {
      "opportunity_actions": "Opportunity actions",
      "actions": "Actions",
      "update": "Update",
      "duplicate": "Duplicate",
      "archive": "Archive"
    },
    "filters": {
      "assign_to": "Assign to",
      "referral_source": "Referral Source",
      "date": "Date",
      "search_placeholder": "Search"
    },
    "columns": {
      "title_description": "Title/Description",
      "opportunity_date": "Opportunity Date",
      "internal_owner": "Internal Owner",
      "internal_owner_email": "Internal Owner (Email)",
      "team_involved": "Team Involved",
      "team_involved_email": "Team Involved (Email)",
      "internal_owner_department": "Internal Owner Department",
      "internal_owner_office": "Internal Owner Office",
      "status": "Status",
      "referral_source_email": "Referral Source (Email)",
      "created_by_email": "Created By (Email)",
      "last_updated": "Last Updated",
      "last_meeting": "Last Meeting",
      "last_sent_email": "Last Sent Email",
      "last_received_email": "Last Received Email",
      "company": "Company",
      "tracking_number": "Tracking Number",
      "tags": "Tags",
      "company_type": "Company Type",
      "company_industries": "Company Industries",
      "company_internal_industries": "Company Internal Industries",
      "company_engagement": "Company Engagement",
      "key_contacts": "Key Contacts",
      "key_contact_names": "Key Contact Names",
      "key_contact_emails": "Key Contact Emails",
      "key_contact_name": "Key Contact Name",
      "key_contact_email": "Key Contact Email",
      "key_contact_country": "Key Contact Country",
      "key_contact_city": "Key Contact City",
      "key_contact_job_title": "Key Contact Job Title",
      "fee": "Fee",
      "referral_source": "Referral Source",
      "created_by": "Created By",
      "referral_source_company": "Referral Source Company",
      "last_interaction": "Last Interaction"
    }
  },
  "opportunity_preview": {
    "created_by": "Created by {{name}} on {{date}}",
    "update_opportunity": "Update Opportunity",
    "create_note": "Create Note",
    "opportunity_number": "Opportunity #{{trackingNumber}}",
    "opportunity_for": "Opportunity for",
    "proposal_for": "Proposal for",
    "industries": "Industries",
    "status": "Status",
    "internal_owner": "Internal Owner",
    "key_contacts": "Key Contacts",
    "title_description": "Title / Description",
    "tags": "Tags",
    "proposed_fee": "Proposed Fee",
    "team_involved": "Team Involved",
    "referral_source": "Referral Source",
    "proposal_documents": "Proposal Documents",
    "linked_workspaces": "Linked Workspaces",
    "share_opportunity": "Share Opportunity",
    "duplicate_opportunity": "Duplicate Opportunity",
    "archive_opportunity": "Archive Opportunity",
    "details": "Details",
    "history": "History",
    "notes": "Notes",
    "link": "Link",
    "view_original_email": "View Original Email"
  },
  "add_document_ui": {
    "add_document_header": "Add Document",
    "add_document_aria_label": "add document",
    "or_separator": "- or -"
  },
  "add_urls": {
    "document_urls_label": "Document URLs (multiple)"
  },
  "custom_status": {
    "show_opportunities_aria": "show {{name}} opportunities",
    "total": "Total",
    "opportunities_short": "Opps",
    "showing_opportunities_tooltip": "Showing {{showing}} opportunities. Switch to List view to see all the {{total}} opportunities",
    "check_all_opportunities": "Check all {{count}} opportunities",
    "last_interaction": "Last interaction:",
    "no_amount": "-"
  },
  "form": {
    "opportunity": "Opportunity",
    "select_company_required": "Select Associated Company *",
    "status": "Status",
    "key_contacts": "Key Contacts",
    "description": "Description",
    "description_placeholder": "Describe your opportunity in one sentence",
    "tags": "Tags",
    "proposed_fee": "Proposed Fee",
    "opportunity_date": "Opportunity Date",
    "date_placeholder": "date",
    "internal_owner": "Internal Owner",
    "internal_owner_placeholder": "Who will be responsible for this opportunity?",
    "team_involved": "Team Involved",
    "team_involved_placeholder": "Team involved in this opportunity?",
    "referral_source": "Referral Source",
    "referral_source_placeholder": "Who referred this opportunity?",
    "key_contacts_placeholder": "Key contacts of the associated company",
    "company_search_placeholder": "Type to search company",
    "reassign_opportunity": "Reassign Opportunity",
    "reassign_opportunity_description": "Reassign this opportunity to another company and update details in the next step",
    "reassigned_opportunity": "Reassigned Opportunity",
    "company": "Company",
    "key_contacts_optional": "Key Contacts (Optional)",
    "edit_opportunity": "Edit Opportunity",
    "save_and_continue": "Save and Continue"
  },
  "view": {
    "opportunity_view_aria": "opportunity view",
    "list_view_aria": "list view",
    "board_view_aria": "board view",
    "list": "List",
    "board": "Board"
  },
  "validation": {
    "company_required": "Please enter a company"
  },
  "notes": {
    "delete": {
      "confirmation_title": "Are you sure you want to delete this note?"
    },
    "actions": {
      "aria_label": "opportunity note actions"
    },
    "added_by": "{{name}} added a note"
  },
  "load_limit": {
    "message": "There are more opportunities than shown. Please refine the opportunity date range to see relevant results."
  },
  "audit_trail": {
    "no_history": "There is no history available for this opportunity",
    "categories": {
      "file_uploaded": "file uploaded",
      "note_archived": "note archived",
      "note_created": "note created",
      "note_updated": "note updated",
      "opportunity_activity": "opportunity activity",
      "opportunity_created": "opportunity created"
    }
  },
  "grid": {
    "loading_alt_text": "Loading opportunities",
    "columns": {
      "company": "Company",
      "title_description": "Title/Description",
      "tracking_number": "Tracking Number",
      "opportunity_date": "Opportunity Date",
      "tags": "Tags",
      "company_type": "Company Type",
      "company_industry_names": "Company Industry Names",
      "company_internal_industry_names": "Company Internal Industry Names",
      "internal_owner": "Internal Owner",
      "internal_owner_email": "Internal Owner (Email)",
      "team_involved": "Team Involved",
      "team_involved_email": "Team Involved (Email)",
      "internal_owner_department": "Internal Owner Department",
      "internal_owner_office": "Internal Owner Office",
      "key_contacts": "Key Contacts",
      "key_contact_names": "Key Contact Names",
      "key_contact_emails": "Key Contact Emails",
      "key_contact_name": "Key Contact Name",
      "key_contact_email": "Key Contact Email",
      "key_contact_country": "Key Contact Country",
      "key_contact_city": "Key Contact City",
      "key_contact_job_title": "Key Contact Job Title",
      "fee": "Fee",
      "status": "Status",
      "referral_source": "Referral Source",
      "referral_source_email": "Referral Source (Email)",
      "created_by": "Created By",
      "created_by_email": "Created By (Email)",
      "referral_source_company": "Referral Source Company",
      "last_interaction": "Last Interaction",
      "last_updated": "Last Updated",
      "last_meeting": "Last Meeting",
      "last_sent_email": "Last Sent Email",
      "last_received_email": "Last Received Email"
    }
  }
}
